import angular from 'angular';

import GenericPanelService from './GenericPanelService';
import GenericPanelComponent from './GenericPanelComponent';

export default angular
  .module('petroCloud.dashboard.genericPanel', [
    'angular-growl',
    'ui.bootstrap',
    'ngSails',
    'petroCloud.infoServices'
  ])
  .service('GenericPanelService', GenericPanelService)
  .component(GenericPanelComponent.name, GenericPanelComponent)
  .name;
